import __request__ from "routing/request";
export function getInvestigation(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/investigations/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateConfiguration(notificationsEnabled, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp/investigations/config/notifications/${notificationsEnabled}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
